import React from 'react';
import PropTypes from 'prop-types';
import translate from '../../../../../../commonComponents/translate';

function ManualPayment(props) {
  const { t, onManualInvoiceSelection, isManualInvoiceSelected } = props;
  const toggleManualInvoice = () =>
    onManualInvoiceSelection(!isManualInvoiceSelected);

  return (
    <div className="m-card_item">
      <label htmlFor="cardSelector" onClick={toggleManualInvoice}>
        <span className="m-card_item__control">
          <span className="m-radio m-radio--state-dynamic">
            <input
              id="cardSelected"
              type="radio"
              name="cardSelected"
              checked={isManualInvoiceSelected}
              onChange={toggleManualInvoice}
            />
            <span />
          </span>
        </span>
        <span className="m-card_item__label">
          <span className="m-card_item__head">
            <span className="m-card_item__title">
              {t('billing_manualPayment')}
            </span>
          </span>
          <span className="m-card_item__body">
            <span>{t('billing_manualPayment_info')}</span>
          </span>
        </span>
      </label>
    </div>
  );
}

ManualPayment.propTypes = {
  t: PropTypes.func.isRequired,
  onManualInvoiceSelection: PropTypes.func.isRequired,
  isManualInvoiceSelected: PropTypes.bool.isRequired,
};

export default translate(ManualPayment);
